import logo from '../../assets/logo.png';
import assinatura from '../../assets/assinatura.png';

export default function Logo() {
  return (
    <div className='flex flex-col items-center mx-auto'>
      <img src={logo} alt="Dika Astral" className='mx-auto' />
      <img src={assinatura} alt="Assinatura" className='w-64 mx-auto mt-4' />
    </div>
  )
}